module.exports = __webpack_public_path__ + "static/media/split.ca992ae7.svg";